import { ANOMALY, FOLLOWUP_QUESTION, PAUSE_REQUEST, TECHNICAL_GUIDE_STATE } from "./constants";
export const questions = {
    anomaly: {
        name: "anomaly",
        labelKey: "serviceCase.proactiveCaseClosure.question.anomaly",
        options: {
            [ANOMALY.DETECTED]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "technicalGuideLinked" },
            [ANOMALY.NOT_DETECTED]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no", next: "pauseRequest" }
        }
    },
    technicalGuideLinked: {
        invisible: true,
        name: "technicalGuideLinked",
        labelKey: "serviceCase.proactiveCaseClosure.question.technicalGuideLinked",
        options: {
            [FOLLOWUP_QUESTION]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "technicalGuideHelpful" },
            [TECHNICAL_GUIDE_STATE.NONE]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no", next: "pauseRequest" }
        }
    },
    technicalGuideHelpful: {
        name: "technicalGuideHelpful",
        labelKey: "serviceCase.proactiveCaseClosure.question.technicalGuideHelpful",
        options: {
            [TECHNICAL_GUIDE_STATE.HELPFUL]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "pauseRequest" },
            [TECHNICAL_GUIDE_STATE.NOT_HELPFUL]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no", next: "pauseRequest" }
        }
    },
    pauseRequest: {
        name: "pauseRequest",
        labelKey: "serviceCase.proactiveCaseClosure.question.pauseRequest",
        options: {
            [FOLLOWUP_QUESTION]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "pauseRequestDuration" },
            [PAUSE_REQUEST.NONE]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no" }
        }
    },
    pauseRequestDuration: {
        name: "pauseRequestDuration",
        labelKey: "serviceCase.proactiveCaseClosure.question.pauseRequestDuration",
        options: {
            [PAUSE_REQUEST.DAYS_7]: { labelKey: "serviceCase.proactiveCaseClosure.answers.sevenDays" },
            [PAUSE_REQUEST.DAYS_14]: { labelKey: "serviceCase.proactiveCaseClosure.answers.fourteenDays" },
            [PAUSE_REQUEST.DAYS_30]: { labelKey: "serviceCase.proactiveCaseClosure.answers.thirtyDays" },
            [PAUSE_REQUEST.DAYS_90]: { labelKey: "serviceCase.proactiveCaseClosure.answers.ninetyDays" }
        },
        comment: {
            name: "comment",
            labelKey: "serviceCase.proactiveCaseClosure.question.comment",
            placeholderKey: "serviceCase.proactiveCaseClosure.question.commentPlaceholder"
        }
    }
};
//# sourceMappingURL=questions.js.map
